module.exports = __webpack_public_path__ + "img/place-2.29eb6da0.svg";